export default {
  loading: '正在加载...',
  categories: {
    basic: '基本',
    object: '对象',
    symbol: '符号',
    arrow: '箭头',
    flowchart: '工作流',
    animal: '动物',
    game: '棋牌',
    dialog_balloon: '会话框',
    electronics: '电子',
    math: '数学',
    music: '音乐',
    misc: '其他',
    raphael_1: 'raphaeljs.com 集合 1',
    raphael_2: 'raphaeljs.com 集合 2'
  },
  buttons: [
    {
      title: '图元库'
    }
  ]
}
